import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { useAuth } from '@features/auth/hooks/useAuth';
import { SiteLayoutWidget } from '@features/shared/ui/SiteLayout/SiteLayoutWidget';
import { ClubListPageWidget } from '@features/club/pages/ClubListPage/ClubListPageWidget';
import { useCallback } from 'react';

export const DEFAULT_CLUB_ID = '777';

export const Route = createFileRoute('/club/')({
  component: () => <Page />,
});

function Page() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const userClubs = user && Object.keys(user.clubs);
  const clubId = userClubs?.[0] || DEFAULT_CLUB_ID;

  const setIsCreateModalOpen = useCallback(
    (isOpen: boolean) => {
      if (isOpen) {
        navigate({
          to: '/club/create',
          from: '/',
        });
      }
    },
    [navigate],
  );

  // Главная. Отображаем список клубов.
  return (
    <SiteLayoutWidget
      clubId={clubId}
      hideCreateTournament
      backgroundPreset="coloured-promo-gradient"
      preset="default-full-width"
    >
      <ClubListPageWidget
        isCreateModalOpen={false}
        setIsCreateModalOpen={setIsCreateModalOpen}
      />
    </SiteLayoutWidget>
  );
}
